"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const AuthContext_1 = __importDefault(require("./AuthContext"));
const auth_client_1 = __importDefault(require("./auth-client"));
const Authentication = (props) => {
    const authApi = new auth_client_1.default;
    const [authState, setAuthState] = (0, react_1.useState)({
        user: null,
        isAuthenticated: null,
    });
    const [authenticating, setAuthenticating] = (0, react_1.useState)(false);
    const setUser = (user, authenticated = true) => {
        setAuthState({ user, isAuthenticated: authenticated });
    };
    const signIn = async (email, password, remember) => {
        return new Promise(async (resolve, reject) => {
            try {
                await authApi.getCsrfCookie();
                await authApi.login(email, password, remember);
                const { user } = await authApi.getUser();
                setUser(user);
                return resolve(user);
            }
            catch (error) {
                return reject(error);
            }
        });
    };
    const signOut = async () => {
        await authApi.logout();
        setAuthState({ user: null, isAuthenticated: false });
    };
    const checkAuthentication = () => {
        return new Promise(async (resolve, reject) => {
            if (authState.isAuthenticated === null) {
                // The status is null if we haven't checked it, so we have to make a request.
                try {
                    const { user } = await authApi.getUser();
                    setUser(user, true);
                    return resolve(true);
                }
                catch (error) {
                    if (error.response && error.response.status === 401) {
                        // If there's a 401 error the user is not signed in.
                        setAuthState({ user: null, isAuthenticated: false });
                        console.log('failed');
                        return resolve(false);
                    }
                    else {
                        // If there's any other error, something has gone wrong.
                        return reject(error);
                    }
                }
            }
            else {
                // If it has been checked with the server before, we can just return the state.
                return resolve(authState.isAuthenticated);
            }
        });
    };
    (0, react_1.useEffect)(() => {
        setAuthenticating(true);
        checkAuthentication().then(() => {
            setAuthenticating(false);
        }).catch(() => {
            console.log('Authentifizierung fehlgeschlagen');
        });
    }, []);
    return (react_1.default.createElement(AuthContext_1.default.Provider, { value: {
            user: authState.user,
            isAuthenticated: authState.isAuthenticated,
            checkAuthentication,
            signIn,
            signOut,
            setUser,
        } }, authState.isAuthenticated === null ? (react_1.default.createElement("div", { className: "min-h-screen flex justify-center items-center" },
        react_1.default.createElement("svg", { className: "animate-spin -ml-1 mr-3 h-10 w-10 text-primary-600", xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24" },
            react_1.default.createElement("circle", { className: "opacity-25", cx: "12", cy: "12", r: "10", stroke: "currentColor", strokeWidth: "4" }),
            react_1.default.createElement("path", { className: "opacity-75", fill: "currentColor", d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" })),
        react_1.default.createElement("div", null, "Wird geladen..."))) : (props.children)));
};
exports.default = Authentication;
